import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { Recommendation } from '../../../models/recommendation/recommendation';
import { UserNamePipe } from '../../../pipes/user-name.pipe';
import { AzureIdStatusPipe } from '../../../pipes/azure-id-status.pipe';

@Component({
  selector: 'app-recommendations-basic-definitions',
  templateUrl: './recommendations-basic-definitions.component.html',
  styleUrls: ['./recommendations-basic-definitions.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatCard,
    MatCardTitle,
    MatFormField,
    MatInput,
    AsyncPipe,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    DatePipe,
    UserNamePipe,
    AzureIdStatusPipe
  ]
})
export class RecommendationsBasicDefinitionsComponent {
  dialog = inject(MatDialog);

  readonly recommendations = input.required<Recommendation>();
  readonly form = input.required<UntypedFormGroup>();

  currentTab = 0;
  datePipe = new DatePipe('en_EU');

  isDefined(): boolean {
    if (this.form()) {
      return true;
    }
    return false;
  }
}
